module.exports = __webpack_public_path__ + "02f1f3ff6dd07a8edf59b00cb47f481a.svg";